/** @type {import('@vue/compat').ComponentOptions} */
export default {
  data: {
    player: '',
    post_id: qk_global.post_id,
    videoList: [],
  },
  mounted() {
    if (!document.getElementById('moeplayer')) return;
    this.$http.post(`${qk_rest_url}getMomentVideoList`, `post_id=${this.post_id}`).then((res) => {
      this.videoList = this.convertDataToVideoList(res.data);
      if (this.videoList.length) {
        this.player = new MoePlayer({
          container: document.getElementById('moeplayer'),
          autoplay: true,
          autonext: false,
          theme: 'var(--theme-color)',
          videoList: this.videoList,
          videoIndex: 0,
        });
      }
    }).catch((err) => {
      qkShowApiError(err, '加载视频失败');
    });
  },
  methods: {
    convertDataToVideoList(data) {
      const videoList = [];

      if (data && Array.isArray(data)) {
        data.forEach((video) => {
          videoList.push({
            id: video.post_id,
            url: video.url,
            pic: video.poster,
          });
        });
      }

      return videoList;
    },
  },
};
